/* COVA core: drawers and popups, scroll reveals, component registry, small helpers.
   Components register with CV.register(selector, init) and are re-initialised on shopify:section:load. */
(function () {
  'use strict';
  var CV = (window.CV = window.CV || {});
  var seen = new WeakSet();
  var registry = [];

  CV.register = function (selector, init) {
    registry.push({ selector: selector, init: init });
    if (document.readyState !== 'loading') run(document, [registry[registry.length - 1]]);
  };
  function run(root, list) {
    (list || registry).forEach(function (r) {
      var nodes = root.querySelectorAll ? Array.prototype.slice.call(root.querySelectorAll(r.selector)) : [];
      if (root.matches && root.matches(r.selector)) nodes.unshift(root);
      nodes.forEach(function (el) {
        if (seen.has(el)) return;
        seen.add(el);
        try { r.init(el); } catch (e) { if (window.console) console.error('[cv] init failed for ' + r.selector, e); }
      });
    });
  }
  document.addEventListener('DOMContentLoaded', function () { run(document); });
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });

  CV.on = function (el, type, fn, opts) { el.addEventListener(type, fn, opts); };
  CV.money = function (cents) {
    var fmt = window.cvMoney || '${{amount}}';
    var n = (Number(cents) / 100).toFixed(2);
    var withCommas = n.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount\s*\}\}/, withCommas).replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas.replace(/\.00$/, '')).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, n.replace('.', ','));
  };

  /* ---------- drawers, popups, sheets ---------- */
  var openStack = [];
  var lastFocus = new WeakMap();
  function focusable(root) {
    return Array.prototype.slice.call(root.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]):not([type=hidden]),select,textarea,[tabindex]:not([tabindex="-1"])')).filter(function (n) { return n.offsetParent !== null || n === document.activeElement; });
  }
  CV.openDrawer = function (id) {
    var d = typeof id === 'string' ? document.getElementById(id) : id;
    if (!d || d.classList.contains('is-open')) return d;
    // only one overlay at a time
    openStack.slice().forEach(function (o) { if (o !== d) CV.closeDrawer(o, true); });
    lastFocus.set(d, document.activeElement);
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    if (d.id !== 'cv-account-drawer') document.body.classList.add('cv-no-scroll');
    openStack.push(d);
    d.dispatchEvent(new CustomEvent('cv:open', { bubbles: true }));
    var panel = d.querySelector('.cv-drawer__panel');
    window.setTimeout(function () {
      var f = panel && focusable(panel)[0];
      if (f) f.focus({ preventScroll: true }); else if (panel) { panel.setAttribute('tabindex', '-1'); panel.focus({ preventScroll: true }); }
    }, 50);
    return d;
  };
  CV.closeDrawer = function (id, quiet) {
    var d = typeof id === 'string' ? document.getElementById(id) : id;
    if (!d || !d.classList.contains('is-open')) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    var i = openStack.indexOf(d);
    if (i > -1) openStack.splice(i, 1);
    if (!openStack.length) document.body.classList.remove('cv-no-scroll');
    d.dispatchEvent(new CustomEvent('cv:close', { bubbles: true }));
    var back = lastFocus.get(d);
    if (!quiet && back && back.focus) try { back.focus({ preventScroll: true }); } catch (e) {}
  };
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-cv-open]');
    if (opener) {
      var d = document.getElementById(opener.getAttribute('data-cv-open'));
      if (d) { e.preventDefault(); CV.openDrawer(d); return; }
    }
    var closer = e.target.closest('[data-cv-close]');
    if (closer) {
      var host = closer.closest('[data-cv-drawer]');
      if (host) { e.preventDefault(); CV.closeDrawer(host); }
    }
  });
  document.addEventListener('keydown', function (e) {
    var top = openStack[openStack.length - 1];
    if (!top) return;
    if (e.key === 'Escape') { CV.closeDrawer(top); return; }
    if (e.key === 'Tab') {
      var panel = top.querySelector('.cv-drawer__panel');
      var f = panel ? focusable(panel) : [];
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  // selects that submit on change (country / language)
  document.addEventListener('change', function (e) {
    var s = e.target.closest && e.target.closest('[data-cv-autosubmit]');
    if (s && s.form) s.form.submit();
  });

  /* ---------- scroll reveal ---------- */
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0 }) : null;
  CV.register('[data-cv-reveal],[data-cv-pills]', function (el) {
    if (!io || reduced) { el.classList.add('is-in'); return; }
    io.observe(el);
  });

  /* ---------- sliders ---------- */
  CV.slider = function (el, options) {
    if (!window.Swiper) return null;
    return new window.Swiper(el, options);
  };
  // generic slider: <div class="swiper" data-cv-slider data-spv="1.2" data-spv-md="3" data-spv-lg="5">...
  // arrows: [data-cv-prev] / [data-cv-next] inside the nearest [data-cv-scope]
  CV.register('[data-cv-slider]', function (el) {
    var scope = el.closest('[data-cv-scope]') || el.parentElement;
    var d = el.dataset;
    var num = function (v, f) { var n = parseFloat(v); return isNaN(n) ? f : n; };
    var opts = {
      slidesPerView: num(d.spv, 1.2),
      spaceBetween: 0,
      speed: num(d.speed, 600),
      loop: d.loop === 'true',
      watchOverflow: true,
      grabCursor: true,
      navigation: { prevEl: scope.querySelector('[data-cv-prev]'), nextEl: scope.querySelector('[data-cv-next]'), disabledClass: 'is-disabled', lockClass: 'is-locked' },
      breakpoints: {}
    };
    opts.breakpoints[768] = { slidesPerView: num(d.spvMd, 3) };
    opts.breakpoints[1024] = { slidesPerView: num(d.spvLg, num(d.spvMd, 3)) };
    var sb = el.querySelector(':scope > .swiper-scrollbar');
    if (sb) opts.scrollbar = { el: sb, draggable: true };
    if (d.autoplay) opts.autoplay = { delay: num(d.autoplay, 4000), disableOnInteraction: false };
    el.swiper_instance = CV.slider(el, opts);
  });
})();
